// 不同模块路由导入
import menuPage from "./menuPage/menuPage";
import generic from "./generic/generic";
import masterData from "./masterData/masterData";
import masterstup from "./masterStup/masterStup";
import tms from "./tms/tms";
let routesArray = [];
let toArray = pages => {
  Object.keys(pages).forEach(key => {
    let obj = pages[key];
    Object.keys(obj).forEach(key => {
      routesArray.push(obj[key]);
    });
  });
};
toArray([menuPage, generic, masterData, masterstup, tms]);
export default routesArray;
